import React from 'react';
import ReactDOM from 'react-dom';
import { Sketch } from 'politico-style';

import Editor from 'lib/Editor';

import { Value } from 'slate';
import defaultValue from './defaultValue';

import 'politico-style/scss/sketch/main.scss';
import '../scss/main.scss';

const { Nav, Footer } = Sketch;

const value = Value.fromJSON(defaultValue);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value };
  }

  render() {
    return (
      <div className='app'>
        <Nav
          appName='Editor Prototype'
          homeLink='https://the-politico.github.io/politico-style/'
          appLink='./'
        />
        <div className='editor'>
          <Editor
            value={this.state.value}
            onChange={({ value }) => this.setState({ value })}
            oembedAPI={'https://politicoapps.com/services/api/oembed/'}
            imageAPI={'https://services.politicoapps.com/api/s3imageservice/'}
            authorization={'Token 2fa8f122c04b4aedbc7d2f8f128b38'}
            placeholder={'Your text here.'}
          />
        </div>
        <Footer />
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('app'));
